import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number) => {
  var oTable = $("#example").dataTable();
  if (page_number == 1) oTable.fnClearTable();
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] == true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var algemeenNaam =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-naam"] +
          "</span>";

        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';
        var model = {
          algemeenNaam: data.content["algemeen-naam"],
          isActive: data.content["algemeen-actief"],
          identification: data["identification"],
        };
        window.$catalog_discipline_Glist.push(model);
        var addId = oTable.fnAddData(
          [checkbox, circleType, algemeenNaam],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[addId[0]]
          .nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }

  $("#total-rows").html(result.meta.total_found);
  $("#cover-spin").hide(0);
  window.$catalog_discipline_scroll_change = true;
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-naam") {
    window.$catalog_discipline_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_discipline_algemeenNaam.push(data);
    });
  }
};

export const disciplineSaved = () => {
  Common.sleep(800).then(() => {
    $("#discipline_toevoegen_modal").modal("hide");
    window.$catalog_discipline_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_discipline_lastUsedTableFilter,
        1,
        window.$catalog_management_units_token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const beheereenheidEdit = () => {
  Common.sleep(1000).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    // that.fillTable(window.$catalog_discipline_lastUsedTableFilter, 1);
    window.$catalog_discipline_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_discipline_lastUsedTableFilter,
        1,
        window.$catalog_management_units_token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type == "activity" && stage.start_allowed == true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$catalog_discipline_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });
  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  // var disciplineToevoegen = $("<a></a>")
  //   .attr({ href: "javascript:void(0)", id: "discipline_toevoegen" })
  //   .addClass("locate discipline")
  //   .html("Discipline toevoegen");
  // $("#myPopup").append(disciplineToevoegen);
  // if (result.data.stages.length > 0) {
  //   var verwijderen = $("<a></a>")
  //     .attr({ href: "javascript:void(0)", id: "verwijderen" })
  //     .addClass("trash-bin beheereenheid")
  //     .html("Verwijderen");
  //   $("#myPopup").append(verwijderen);
  // }

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};
export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id == "algemeen-naam") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_discipline_algemeenNaam.push(data);
    });
  }
};
